import {IntlKeyValuePair, IntlNamespaces} from "./types";

export const INTL_BLOGS: IntlKeyValuePair = {
    key: "blogs",
    defaultValue: "Blogs",
    intlValue: "Blogs",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_CONTENT_FEED: IntlKeyValuePair = {
    key: "contentFeed",
    defaultValue: "Content Feed",
    intlValue: "Content Feed",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_NO_BLOGS_MESSAGE: IntlKeyValuePair = {
    key: "noBlogsMessage",
    defaultValue: "Tell us what you are interested in, and we’ll make sure to keep you posted.",
    intlValue: "Tell us what you are interested in, and we’ll make sure to keep you posted.",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_MINUTE_READ: IntlKeyValuePair = {
    key: "minuteRead",
    defaultValue: "min read",
    intlValue: "min read",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_MINUTE_SHORT_SINGULAR: IntlKeyValuePair = {
    key: "minuteShort",
    defaultValue: "min",
    intlValue: "min",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_MINUTE_SHORT_PLURAL: IntlKeyValuePair = {
    key: "minuteShort",
    defaultValue: "mins",
    intlValue: "mins",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_BLOGS_COMING_SOON: IntlKeyValuePair = {
    key: "blogsComingSoon",
    defaultValue: "Blogs are coming soon!",
    intlValue: "Blogs are coming soon!",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_VIEWS: IntlKeyValuePair = {
    key: "views",
    defaultValue: "views",
    intlValue: "views",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_BLOG_NOT_FOUND_ERROR: IntlKeyValuePair = {
    key: "blogNotFoundError",
    defaultValue: "Blog post not found",
    intlValue: "Blog post not found",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_BLOG_NOT_FOUND_MESSAGE: IntlKeyValuePair = {
    key: "blogNotFoundMessage",
    defaultValue: "Sorry, it appears that this blog post is not available",
    intlValue: "Sorry, it appears that this blog post is not available",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_SHARE_BLOG: IntlKeyValuePair = {
    key: "shareBlog",
    defaultValue: "Share blog",
    intlValue: "Share blog",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_SHARE: IntlKeyValuePair = {
    key: "share",
    defaultValue: "Share",
    intlValue: "Share",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_BACK: IntlKeyValuePair = {
    key: "back",
    defaultValue: "Back",
    intlValue: "Back",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_SEE_MORE: IntlKeyValuePair = {
    key: "seeMore",
    defaultValue: "See more",
    intlValue: "See more",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_FIND_MORE: IntlKeyValuePair = {
    key: "findMore",
    defaultValue: "Want to find out more?",
    intlValue: "Want to find out more?",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_CHAT_WITH_STUDENTS: IntlKeyValuePair = {
    key: "chatWithStudents",
    defaultValue: "Chat with students",
    intlValue: "Chat with students",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_SEARCH: IntlKeyValuePair = {
    key: "search",
    defaultValue: "Search title",
    intlValue: "Search title",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_SUBJECT: IntlKeyValuePair = {
    key: "subject",
    defaultValue: "Subject",
    intlValue: "Subject",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_TOPIC: IntlKeyValuePair = {
    key: "topic",
    defaultValue: "Topic",
    intlValue: "Topic",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_SORT: IntlKeyValuePair = {
    key: "sort",
    defaultValue: "Sort",
    intlValue: "Sort",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_DATE_PUBLISHED: IntlKeyValuePair = {
    key: "datePublished",
    defaultValue: "Date published",
    intlValue: "Date published",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_MOST_VIEWED: IntlKeyValuePair = {
    key: "mostViewed",
    defaultValue: "Most viewed",
    intlValue: "Most viewed",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_AUTHOR_AVATAR: IntlKeyValuePair = {
    key: "authorAvatar",
    defaultValue: (authorName: string) => `${authorName}'s avatar`,
    intlValue: "{{authorName}}'s avatar",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_AUTHOR_DEGREE: IntlKeyValuePair = {
    key: "authorDegree",
    defaultValue: (authorName: string, degree: string) => `${authorName} is studying ${degree}`,
    intlValue: "{{authorName}} is studying {{degree}}",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_AUTHOR_NATIONALITY: IntlKeyValuePair = {
    key: "authorNationality",
    defaultValue: (authorName: string, primaryFlag: string) =>
        `${authorName} is from ${primaryFlag}`,
    intlValue: "{{authorName}} is from {{primaryFlag}}",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_AUTHOR_PRIMARY_AND_SECONDARY_FLAG: IntlKeyValuePair = {
    key: "authorPrimaryAndSecondaryFlag",
    defaultValue: (authorName: string, primaryFlag: string, secondaryFlag: string) =>
        `${authorName} is primarily from ${primaryFlag} and the secondary country is ${secondaryFlag}`,
    intlValue:
        "{{authorName}} is primarily from {{primaryFlag}} and the secondary country is {{secondaryFlag}}",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_CONTENT_TILE_TEXT: IntlKeyValuePair = {
    key: "contentTileText",
    defaultValue: (title: string, authorName: string) => `${title} post written by ${authorName}`,
    intlValue: "{{title}} post written by {{authorName}}",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_CONTENT_TITLE: IntlKeyValuePair = {
    key: "contentTitle",
    defaultValue: (title: string) => `Blog Title: ${title}`,
    intlValue: "Blog Title: {{title}}",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_CONTENT_BODY_PREVIEW: IntlKeyValuePair = {
    key: "contentBodyPreview",
    defaultValue: (body: string) =>
        `Here's the blog preview. ${body} Click to view the entire blog`,
    intlValue: "Here's the blog preview. {{body}} Click to view the entire blog",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_CONTENT_BODY: IntlKeyValuePair = {
    key: "contentBody",
    defaultValue: (body: string) => `Blog content: ${body}`,
    intlValue: "Blog content: {{body}}",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_CONTENT_READ_TIME: IntlKeyValuePair = {
    key: "contentReadTime",
    defaultValue: (readingTime: string, minutesDesc: string) =>
        `Blog takes ${readingTime} ${minutesDesc} to read`,
    intlValue: "Blog takes {{readingTime}} {{minutesDesc}} to read",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_CONTENT_NUMBER_OF_VIEWS: IntlKeyValuePair = {
    key: "contentNumberOfViews",
    defaultValue: (views: string) => `Blog has been viewed ${views} times`,
    intlValue: "Blog has been viewed {{views}} times",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_CONTENT_PUBLISHED_DATE: IntlKeyValuePair = {
    key: "contentPublishedDate",
    defaultValue: "Blog was published on",
    intlValue: "Blog was published on",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_READ_TIME_IMAGE: IntlKeyValuePair = {
    key: "readTimeImage",
    defaultValue: "Read image for presentation",
    intlValue: "Read image for presentation",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_NO_OF_VIEWS_IMAGE: IntlKeyValuePair = {
    key: "noOfViewsImage",
    defaultValue: "View image for presentation",
    intlValue: "View image for presentation",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_CONTENT_PUBLISHED_DATE_IMAGE: IntlKeyValuePair = {
    key: "contentPublishedDateImage",
    defaultValue: "Blog published date image for presentation",
    intlValue: "Blog published date image for presentation",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_SHARE_BUTTON_TEXT: IntlKeyValuePair = {
    key: "shareButtonText",
    defaultValue: "Click on this to share with your buddies",
    intlValue: "Click on this to share with your buddies",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_PUBLISHED_BY: IntlKeyValuePair = {
    key: "publishedBy",
    defaultValue: (authorName: string) => `Published by ${authorName}`,
    intlValue: "Published by {{authorName}}",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_COMES_FROM: IntlKeyValuePair = {
    key: "comesFrom",
    defaultValue: (place: string) => `Comes from ${place}`,
    intlValue: "Comes from {{place}}",
    namespace: IntlNamespaces.BLOGS,
};

export const INTL_VIEW_CONTENT: IntlKeyValuePair = {
    key: "viewContent",
    defaultValue: "View Content",
    intlValue: "View Content",
    namespace: IntlNamespaces.BLOGS,
};
